import React from "react";
import { SlideHome } from "../../components/home/slide-home";
import BackgroundSlider from "../../components/home/slide-home/BackgroundSlider";
import BestSellers from "../../components/home/BestSellers";
import CategoriesSection from "../../components/home/CategoriesSection";
import PromoSection from "../../components/home/PromoSection";
import { DisponibleSection } from "../../components/home/DisponibleSection";
import { NouveauxProduits } from "../../components/home/NouveauxProduits";

import ParallaxSection from "../../components/home/AnimatedSection";
import NosCertification from "../../components/home/CertificationSection";
import TestimonialsSection from "../../components/home/TestimonialsSection";
import LandingSection from "../../components/home/NewsletterSection";

export const HomePage = () => {
  return (
    <div>
      <BackgroundSlider />
      <BestSellers />
      <CategoriesSection />
      <PromoSection />
      <DisponibleSection />
      <NouveauxProduits />
      <ParallaxSection />
      <NosCertification />
      <TestimonialsSection />
    </div>
  );
};
